import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpUtilsService } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';

export enum tagsViewContext {
  COMMUNICATION = 'communication',
  ENTITIES = 'entities',
  CONTACTS = 'contacts',
}

@Injectable({
  providedIn: 'root',
})
export class SharedHttpRequestService {
  private authToken;
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getTagsForView(id, viewContext): Observable<any> {
    let baseURL = '';
    switch (viewContext) {
      case tagsViewContext.COMMUNICATION:
        baseURL = environment.TIMELINE_BASE;
        break;
      case tagsViewContext.ENTITIES:
        baseURL = environment.CORE_BASE;
        break;
      case tagsViewContext.CONTACTS:
        baseURL = environment.CORE_BASE;
        break;
    }
    const url = `${baseURL}/companies/${this.companyId}/${viewContext}/${id}/tags`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers: httpHeaders });
  }
}
